import { useValue } from "@legendapp/state/react";
import { Icon } from "@repo/ui/components/icon";
import { Tooltip, TooltipContent, TooltipTrigger } from "@repo/ui/tooltip";
import { Button } from "@repo/ui/ui/button";
import { useCanGoBack, useRouter } from "@tanstack/react-router";

import { chat$ } from "~/stores/chat";

/**
 * Navigates back from the full-page thread view to wherever the user came from
 * (history back). Hidden when there is nothing to go back to (direct load / new
 * tab). Opens the docked chat pane so the conversation continues in the side
 * pane when back lands on a chat-pane route. Disabled while streaming so we
 * don't unmount the active `useChat` instance and drop the in-flight response.
 */
export const ThreadCollapseButton = () => {
  const router = useRouter();
  const canGoBack = useCanGoBack();
  const isStreaming = useValue(chat$.isStreaming);

  if (!canGoBack) return null;

  const handleBack = () => {
    if (chat$.isStreaming.get()) return;
    chat$.isOpen.set(true);
    router.history.back();
  };

  return (
    <Tooltip>
      <TooltipTrigger
        render={
          <Button
            variant="ghost"
            size="icon-sm"
            onClick={handleBack}
            disabled={isStreaming}
            aria-label="Back"
          >
            <Icon name="arrow-left" />
          </Button>
        }
      />
      <TooltipContent>Back</TooltipContent>
    </Tooltip>
  );
};
